export default {
    /**
     * Commits flash message into state
     * @param {Object} state - Current state
     * @param {String} payload - Flash message
     */
    setFlash(state, { flash, flashKey }) {
        state.flash = flash;
        state.flashKey = flashKey;
    },

    /**
     * Clears current flash message from state
     * @param {Object} state - Current state
     */
    clearFlash(state) {
        state.flash = '';
        state.flashKey = '';
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Flash/mutations.js